// extracted by mini-css-extract-plugin
module.exports = {"counterpart":"Counterpart_counterpart__3H3RP","total":"Counterpart_total__aZ2id","fadeIn":"Counterpart_fadeIn__1DDSu","fadeOut":"Counterpart_fadeOut__MBCtQ"};